import type { TemplateFn } from "./index";
import { ROOT_TARGET, baseTimeline } from "./_helpers";

// Spin-in for round marks. -120° to 0 (not the previous -180° — half a turn
// is too much; quarter-plus reads as elegant). Subtle scale overshoot keeps
// it from feeling like a pinwheel.
export const radialReveal: TemplateFn = (ir, logo) => {
  const base = baseTimeline(ir, logo);
  return {
    ...base,
    tracks: [{
      target: ROOT_TARGET,
      easing: "easeOutExpo",
      delay: 0,
      keyframes: [
        { t: 0.00, opacity: 0, scale: 0.35, rotate: -120, filter: "blur(4px)" },
        { t: 0.55, opacity: 1, scale: 1.07, rotate:    4, filter: "blur(0px)" },
        { t: 0.78, scale: 0.98, rotate: -1 },
        { t: 1.00, opacity: 1, scale: 1,    rotate: 0 },
      ],
    }],
  };
};
